import * as oPath from '../../../Lib/Object/Path/Mutable';
import { createSlice } from '@reduxjs/toolkit';
import {
  CleanupAction,
  GetAction,
  GetRejectAction,
  GetResolveAction,
  InitAction,
  InitResolveAction,
  ListsState,
  ListState,
} from './types';
import { isNil } from 'ramda';

const name = 'lists';

const initialState: ListsState = {};

const initialListState: ListState = {
  searching: false,
  firstSearchComplete: false,
  items: [],
  options: { freeEntry: false },
};

export const { reducer, actions } = createSlice({
  name,
  initialState,
  reducers: {
    init: (state, action: InitAction) => {
      const { payload: { id } = {} } = action;
      oPath.set(state, id, initialListState);
    },
    initResolve: (state, action: InitResolveAction) => {
      const { payload: { id, options } = {} } = action;
      // Ignore if no options returned likely means no options endpoint for this list
      if (!options) return;
      oPath.set(state, id, { options });
    },
    initReject: (state, action: GetRejectAction) => {
      // Use initialListState options
    },
    cleanup: (state, action: CleanupAction) => {
      const { payload: { id } = {} } = action;
      oPath.del(state, id);
    },
    get: (state, action: GetAction) => {
      const { payload: { id } = {} } = action;
      // Ignore if list has been cleaned up
      if (isNil(oPath.get(state, id))) return;
      oPath.setMultiple(state, id, { searching: true });
    },
    getResolve: (state, action: GetResolveAction) => {
      const { payload: { id, items } = {} } = action;
      // Ignore if list has been cleaned up
      if (isNil(oPath.get(state, id))) return;
      oPath.setMultiple(state, id, { items, searching: false, firstSearchComplete: true });
    },
    getReject: (state, action: GetRejectAction) => {
      const { payload: { id } = {} } = action;
      // Ignore if list has been cleaned up
      if (isNil(oPath.get(state, id))) return;
      oPath.setMultiple(state, id, { searching: false });
    },
  },
});
